var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sourcescode"},[_c('div',{staticClass:"exerpt-wrapper",on:{"click":_vm.toggleRun}},[_c('pre',[_vm._v("      "),_c('div',{staticClass:"inner-block"},[_vm._v(_vm._s(_vm.dataDetails.exerpt))]),_vm._v("\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }